import { render, staticRenderFns } from "./supplement-approved.vue?vue&type=template&id=11805261"
import script from "./supplement-approved.vue?vue&type=script&lang=ts"
export * from "./supplement-approved.vue?vue&type=script&lang=ts"
import style0 from "./supplement-approved.vue?vue&type=style&index=0&id=11805261&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports